<template>
  <notifications :width="width" :position="position" class="notification-wrapper">
    <template slot="body" slot-scope="props">
      <div
        class="notification-text"
        :class="'notification is-' + props.item.type"
        @click="props.close"
      >
        <button class="delete" @click="props.close" />
        {{ props.item.text }}
        <span v-if="(props.item.data || []).length > 0">
          Dettagli:
          <br />
          <ol type="1">
            <li v-for="detail in props.item.data" :key="detail">{{ detail }}</li>
          </ol>
        </span>
      </div>
    </template>
  </notifications>
</template>
<script>
export default {
	name: "NotificationsWrapper",
  props: {
    position: {
      type: String,
      default: () => 'top right'
    },
    width: {
      type: String,
      default: () => '300'
    }
  }
}
</script>
<style lang="scss">
.notification-wrapper {
  margin-bottom: $navbar-height;
}

.notification-text {
  margin: 8px 8px 0px 8px;
  cursor: pointer;
  padding: 1rem 1.25rem 1rem 1rem !important;
}
</style>
